import {
  getPointsImageSpec,
  getPointsStyleSpec
} from '@/utils/layers/styleFactory/radius'
import { PartialLayerSpec } from '@/utils/layers/styleFactory/template'
import { ILayerValue } from '@lifk/types'
import { ExpressionSpecification } from 'mapbox-gl'

export default (
  layerValues: ILayerValue[],
  mapboxColorExpression: string | ExpressionSpecification,
  mapboxOpacityExpression?: ExpressionSpecification | number
): PartialLayerSpec[] => {
  const config = layerValues.map(({ styleConfig, layerConfig }) => ({
    radius: styleConfig.radius,
    filter: layerConfig.filter,
    imageId: styleConfig.pointIcon?.assetId
  }))

  // Optionally add a symbol layer for low-density points with icons
  const image = getPointsImageSpec(config)
  if (image) {
    return [
      {
        id: 'points',
        type: 'symbol',
        paint: {
          'icon-occlusion-opacity': 1,
          'icon-opacity': mapboxOpacityExpression
        },
        layout: {
          ...image,
          'icon-padding': 0,
          'icon-allow-overlap': true
        }
      }
    ] as PartialLayerSpec[]
  }

  // Otherwise normal points
  const { radius, borderWidth } = getPointsStyleSpec(config)
  return [
    {
      id: 'points',
      type: 'circle',
      layout: {},
      paint: {
        'circle-radius': radius,
        'circle-color': mapboxColorExpression,
        'circle-stroke-color': '#fff',
        'circle-stroke-width': borderWidth,
        'circle-pitch-alignment': 'map',
        'circle-opacity': mapboxOpacityExpression
      }
    }
  ] as PartialLayerSpec[]
}
